export default {
  header: {
    title: 'Comprar tarjeta regalo',
  },
  checkout_btn: {
    title: 'Pagar',
  },
  items: {
    gift_card: {
      online: 'Tarjeta regalo solo canjeable en línea',
      online_and_store: 'Tarjeta regalo (canjeable en línea y en tienda)',
      title: 'Selecciona el importe deseado',
      description: 'Añade la tarjeta regalo con la cantidad deseada al carrito',
    },
    expiration: {
      label: 'Válida por 3 años',
      title: '¡Disfruta regalando!',
      description: 'El destinatario puede canjear el vale de forma flexible en 3 años.',
    },
    delivery: {
      label: 'Entrega inmediata en PDF por correo electrónico',
      title: 'Entrega instantánea en PDF por correo electrónico',
      description: 'Tras el pago seguro recibirás el vale de inmediato.',
    },
  },
  form: {
    value: {
      title: 'Elige el importe de la tarjeta regalo',
      custom: {
        label: 'Personalizado',
        placeholder: 'Introduce un importe entre {{min}} y {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Cantidad',
    },
    email: {
      title: '¿Cuál es tu correo electrónico para enviarte la tarjeta regalo?',
      placeholder: 'Tu correo electrónico',
      error: 'Correo inválido',
    },
  },
  confirmation: {
    title: {
      title: '¿Comprar tarjeta regalo?',
      subtitle_one: '¿Deseas comprar 1 tarjeta regalo por {{value}}?',
      subtitle_other: '¿Deseas comprar {{count}} tarjetas regalo por {{value}}?',
    },
    description: {
      total: 'Total:',
      email: 'Email:',
      quantity: 'Cantidad',
      amount: 'Importe',
    },
    footer: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
  },
};
